URL = { 
  "list":"/mast/matrlTypemng/MaterialType/select",//物料类型管理-查询物料类型列表
	"add":"/mast/matrlTypemng/MaterialType/add",//物料类型管理-添加物料组
	"modify":"/mast/matrlTypemng/MaterialType/modify",//物料类型管理-修改物料类型
	"find":"/mast/matrlTypemng/MaterialType/find",//物料类型管理-查询物料类型
	"del":"/mast/matrlTypemng/MaterialType/delete",//物料类型管理-删除物料类型
	"restore":"/mast/matrlTypemng/MaterialType/restore"//物料类型管理-恢复已删除物料类型
}

/**
 * 搜索物料类型
 * @param {} data 
 * @param {*} cb 
 */
async function searchMaterialTypes(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.list,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

/**
 * 添加物料类型
 * @param {} data 
 * @param {*} cb 
 */
async function  submitNewMtrlType(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.add,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

/**
 * 修改物料类型
 * @param {} data 
 * @param {*} cb 
 */
async function  submitModifyMtrlType(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.modify,data);
  if(cb&&resResult){
    cb(resResult);
  }
}



/**
 * 查找物料类型信息
 * @param {*} data 
 * @param {*} cb 
 */
async function loadMtrlType(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$get(URL.find,data);
  if(cb&&resResult){
    cb(resResult);
  }
}


/**
 * 删除物料类型信息
 * @param {*} data 
 * @param {*} cb 
 */
async function submitDelMtrlType(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$get(URL.del,data);
  if(cb&&resResult){
    cb(resResult);
  }
}


/**
 * 恢复删除物料类型信息
 * @param {*} data 
 * @param {*} cb 
 */
async function restoreMaterialType(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$get(URL.restore,data);
  if(cb&&resResult){
    cb(resResult);
  }
}




export const URL_PLATFORM_RESOURCE = URL;

export default{
  searchMaterialTypes,
  submitNewMtrlType,
  submitModifyMtrlType,
  loadMtrlType,
  submitDelMtrlType,
  restoreMaterialType
}


